module.exports = __webpack_public_path__ + "static/img/k4.ea0fa315.png";